module.exports = __webpack_public_path__ + "static/media/blog9.16da5b9e.webp";